import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCiRqY_TzHI4gACiN_Zsgs3c7QXJ0yO5ZY",
    authDomain: "master-thesis-forms.firebaseapp.com",
    projectId: "master-thesis-forms",
    storageBucket: "master-thesis-forms.appspot.com",
    messagingSenderId: "110477183276",
    appId: "1:110477183276:web:236fea7d8893d864ac0489",
    measurementId: "G-3HDG7ZQTXX"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics()

const db = firebase.firestore()

export default db;


createApp(App).mount('#app')